'use client';
import { css } from 'styled-system/css'
import { center, flex } from 'styled-system/patterns';

export const styles = {
	container: center({
		mx: '15px',
		padding: '6px 0',
		borderTop: '1px solid',
		borderBottom: '1px solid',
		borderColor: 'black.5',
		gap: '3px',
		cursor: 'pointer',
		_hover: {
			color: 'brand.500_light',
		},
		'&[data-open=true]': {
			'& .icon': {
				transform: 'rotate(180deg)',
			}
		}
	}),
	text: css({
		fontSize: '14px',
	}),
}